import { render, staticRenderFns } from "./TodoLeftSidebar.vue?vue&type=template&id=35da5368"
import script from "./TodoLeftSidebar.vue?vue&type=script&lang=js"
export * from "./TodoLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports